import React, { useMemo } from 'react'
import { makeStyles } from '@material-ui/core'
import { Link, useHistory } from 'react-router-dom'
import { useCheckPolicy } from '../../../../../hooks'
import NotAvailable from '../../../../organisms/NotAvailable'
import OperationalTable from '../../../../organisms/OperationalTable'
import { ADMIN_ROUTES } from '../../../../../constants'
import { useSearchStatusTemplates } from '../../../../../api/groups'
import SydLinkButton from '../../../../commonDesign/LinkButton'

const useStyles = makeStyles((theme) => ({
  container: {
    padding: '1rem'
  },
  actions: {
    marginLeft: 'auto',
    display: 'flex',
    gap: '0.5rem'
  }
}))

const cellTemplates = {
  link: (accessor) => ({ row }) => (
    <Link
      onClick={(event) => event.stopPropagation()}
      to={`${ADMIN_ROUTES.STATUS_REPORTS.TEMPLATES.HOME}/${row.original.statusTemplateId}`}
    >
      {accessor(row.original) || 'Link'}
    </Link>
  )
}

function StatusReportTemplatesHome () {
  const classes = useStyles()
  const canViewStatusReports = useCheckPolicy('admin_view_status_templates')
  const canEditStatusReports = useCheckPolicy('admin_edit_status_templates')

  const query = useMemo(() => {
    return { take: 200 }
  }, [])
  const history = useHistory()
  const { data, isLoading } = useSearchStatusTemplates(query, {
    enabled: canViewStatusReports
  })

  if (!canViewStatusReports) {
    return <NotAvailable />
  }

  return (
    <div className={classes.container}>
      <div className='flex items-center mb-4'>
        {canEditStatusReports && (
          <SydLinkButton
            size='sm'
            variant='outline'
            icon='add'
            to={ADMIN_ROUTES.STATUS_REPORTS.TEMPLATES.NEW}
          >
            Add Status Report Template
          </SydLinkButton>
        )}
      </div>
      <OperationalTable
        variant='v2'
        mode='client'
        itemName='Status Report Templates'
        data={data?.data || []}
        loading={isLoading}
        total={data?.data?.length}
        columns={[
          { Header: 'Id', accessor: 'statusTemplateId', type: 'number', Cell: cellTemplates.link(row => row.statusTemplateId) },
          { Header: 'Name', accessor: 'name', type: 'string', Cell: cellTemplates.link(row => row.name) },
          { Header: 'Description', accessor: 'description', type: 'string' },
          { Header: 'Purpose Key', accessor: 'purposeKey', type: 'string' }
        ]}
        defaultSort={[{ id: 'statusTemplateId', desc: false }]}
        onRowClick={(row) => history.push(`${ADMIN_ROUTES.STATUS_REPORTS.TEMPLATES.HOME}/${row.original.statusTemplateId}`)}
      />
    </div>
  )
}

export default StatusReportTemplatesHome
